import React from 'react';
import { translate } from '../Services/translation';

const CheckoutPrivateCustomerInfo = (props) => {
  const { onChange, errors = {} } = props;
  const input = (cssClass, stateKey, id, autoComplete = 'on', type = 'text') => (
    <div className={cssClass}>
      <input
        className="form__input"
        id={`${stateKey}-${id}`}
        name={`${stateKey}-${id}`}
        type={type}
        placeholder={translate(`checkout.customerinfo.${id.toLowerCase()}`) + '*'}
        value={(props[stateKey] || {})[id] || ''}
        autoComplete={autoComplete}
        onChange={(event) => onChange(stateKey, id, event.target.value)}
      />
      {errors[`${stateKey}-${id}`] && (
        <span
          className="form__validator--error form__validator--top-narrow"
          data-error-for={`${stateKey}-${id}`}
        >
          {errors[`${stateKey}-${id}`][0]}
        </span>
      )}
    </div>
  );
  return (
    <div className="row">
      {input(
        'small-12 medium-6 columns',
        'customerDetails',
        'firstName',
        'billing given-name'
      )}
      {input(
        'small-12 medium-6 columns',
        'customerDetails',
        'lastName',
        'billing family-name'
      )}
      {input(
        'small-12 medium-6 columns',
        'customerDetails',
        'phoneNumber',
        'billing tel'
      )}
      {input('small-12 medium-6 columns', 'customerDetails', 'email', 'email')}
    </div>
  );
};

export default CheckoutPrivateCustomerInfo;
